<div class="container">
  <div class="column first-column">
    <div class="row">Viscosity Modifier</div>

    @for (row of rows; track row; let i = $index) {
    <div class="row">
      <div class="select-container">
        <span class="delete-icon" (click)="clearRowData(i)">✕</span>
        <div class="custom-select-wrapper">
          <input
            type="text"
            class="custom-select-input"
            [formControl]="vmControls[i]"
            [matAutocomplete]="auto"
            (blur)="onVmInputBlur(i)"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="displayFn"
            (optionSelected)="onVmSelected($event, i)"
            panelClass="custom-autocomplete-panel"
          >
            <cdk-virtual-scroll-viewport
              itemSize="36"
              class="autocomplete-viewport"
            >
              <mat-option
                *cdkVirtualFor="let option of filteredVmOptions[i]"
                [value]="option"
              >
                {{ option.label }}
              </mat-option>
            </cdk-virtual-scroll-viewport>
          </mat-autocomplete>
        </div>
      </div>
    </div>
    }
  </div>
  <div class="column third-column"></div>
  <div class="column third-column"></div>
  <div class="column third-column">
    <div class="row centered">&nbsp;</div>
    @for (row of rows; track row; let i = $index){
    <div class="row centered">
      <input
        type="text"
        inputmode="decimal"
        [(ngModel)]="row.treat1"
        placeholder=""
        (keydown)="restrictNumericInput($event)"
        (input)="handleTreatInput($event, i, 'treat1')"
        (change)="calculateAndEmitTotals()"
        (blur)="onTreatBlur(i, 'treat1')"
      />
    </div>
    }
  </div>
  <div class="column third-column"></div>
  <div class="column fourth-column">
    <div class="row centered">&nbsp;</div>
    @for (row of rows; track row; let i = $index){
    <div class="row centered">
      <input
        type="text"
        inputmode="decimal"
        [(ngModel)]="row.treat2"
        placeholder=""
        (keydown)="restrictNumericInput($event)"
        (input)="handleTreatInput($event, i, 'treat2')"
        (change)="calculateAndEmitTotals()"
        (blur)="onTreatBlur(i, 'treat2')"
      />
    </div>
    }
  </div>
</div>
<!-- <div class="legend">
    <p (click)="addRow()">add another +</p>
  </div> -->
